var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "images",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.975,
    height: 16.293,
    viewBox: "0 0 20.975 16.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 20.975,
    height: 16.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 22,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M1244.12,682.987h-18.257a1.36,1.36,0,0,0-1.358,1.359v13.576a1.359,1.359,0,0,0,1.358,1.358h18.257a1.36,1.36,0,0,0,1.359-1.358V684.346A1.361,1.361,0,0,0,1244.12,682.987Zm-7.207,12.121a.652.652,0,0,0,.81.02l4.312-3.233,2.131,1.421v4.606c0,.034-.012.045-.046.045h-18.257c-.034,0-.045-.011-.045-.045V693.5l4.5-3.884Zm4.71-4.545-4.27,3.2-6.623-5.523a.664.664,0,0,0-.416-.149.6.6,0,0,0-.074.005.655.655,0,0,0-.36.154l-4.062,3.513v-7.419c0-.034.011-.046.045-.046h18.257c.034,0,.046.012.046.046v7.384l-1.793-1.189A.66.66,0,0,0,1241.623,690.563Z",
    transform: "translate(-1224.505 -682.987)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 21,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M1237.658,686.081a2.3,2.3,0,1,0,2.3,2.295,2.3,2.3,0,0,0-2.3-2.295m.982,2.295a.982.982,0,1,1-.982-.982.972.972,0,0,1,.982.982",
    transform: "translate(-1235.363 -686.081)",
    fill: "none",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(-1 -0.188)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(1 0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0 -0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 30.975,
    height: 26.293,
    transform: "translate(-5 -4.812)",
    fill: "#404149"
  }))))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(10.859 3.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 14.59,
    height: 14.59,
    transform: "translate(-5 -5)",
    fill: "#404149"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.2b7c504dea8518bbb7d0b63ffed19661.svg";
export { ForwardRef as ReactComponent };